import React from 'react';
import { DataList } from 'commons-ui';

import { columnConfigs } from './listConfig';
import useService from '../../utils/useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';

interface IVersionHistoryListProps {
	entity: string;
	dashboard: string;
	pageName: string;
	entityName: string;
	id: string;
	usePageActions: any;
}

const VersionHistoryList: React.FC<IVersionHistoryListProps> = (props) => {
	const { entity, dashboard, pageName, entityName, id, usePageActions } = props;
	const { getActionHandler, getActionList } = usePageActions(makeActionHandler(pageName, entityName), makeActionList);
	const actions = getActionList();
	const { getVersionHistory } = useService();

	return (
		<DataList
			fetchData={getVersionHistory(dashboard, pageName, entityName, id)}
			columnConfigs={columnConfigs(dashboard, pageName, entityName, id)}
			getActionHandler={getActionHandler}
			actions={actions}
			entity={entity}
		/>
	);
};

export default VersionHistoryList;
